import { IFlowData } from "@leafer-ui/interface"
import { BoxData } from '@leafer-ui/draw'


export class FlowData extends BoxData implements IFlowData {

}
